<template>
  <div>
    <div class="order_paid">
      <div v-show="this.paidGoods.length" class="order_have">
        <ul class="order_paid_top">
          <li>商品画像</li>
          <li>商品名</li>
          <li>商品単価</li>
          <li>商品数量</li>
          <li>設定</li>
        </ul>
        <div class="order_paid_main">
          <ul class="order_paid_center">
            <li><span><img src="../../assets/images/goods/cart_goods_img.png"></span></li>
            <li><p><span>持续吸收性VB</span></p></li>
            <li><p><span>960</span></p></li>
            <li><p><span>2</span></p></li>
            <li><p><span><button @click="todetial">注文の詳細</button></span></p></li>
          </ul>
          <div class="order_paid_footer">
            <span>小計：<label>￥132</label></span>
            <span>合計 <label>1</label>点</span>
          </div>
        </div>
      </div>
      <div v-show="this.paidGoods.length" class="order_Phave">
        <ul class="order_paid_top">
          <li>商品画像</li>
          <li>商品名</li>
          <li>数量</li>
          <li>商品単価</li>
        </ul>
        <div class="order_paid_main">
          <ul class="order_paid_center">
            <li><img src="../../assets/images/goods/cart_goods_img.png"></li>
            <li><p><span> 持续吸收性VB</span></p></li>
            <li><p><span>X2</span></p></li>
            <li><p><span>￥960</span></p></li>
          </ul>
          <p class="order_paid_Pcenter">
            <span>共1件商品</span><span>合计：<label>￥960.00</label></span></p>
          <div class="order_paid_footer">
            <span>注文の詳細</span>
          </div>
        </div>
      </div>
      <div v-show="!this.paidGoods.length" class="order_no">
        <img src="../../assets/images/personal/wu.png" height="315" width="175"/>
        <span>関連注文はありません。</span>
      </div>
      <div v-show="!this.paidGoods.length" class="order_Pno">
        <img src="../../assets/images/personal/wu.png" height="315" width="175"/>
        <span>関連注文はありません。</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default{
    name: "",
    data(){
      return {
        paidGoods:[1],
      }
    },
    methods: { todetial(){
      this.$router.push({
        path: "/personal/detial",
      })
    },},
    components: {}
  }
</script>
<style lang="scss">
  @import "../../../static/pubilc.scss";
  @media screen and(min-width: $min-screen) and(max-width: $P749screen) {
    .order_paid {
      width: 100%;
      font-size: 14/$default-w+rem;
      .order_have{
        display: none;
      }
      .order_Phave{
        .order_paid_top {
          width: 100%;
          height: 20px;
          padding: 10px 0;
          line-height: 20px;
          background-color: $bgcolor;
          li {
            float: left;
            width: 25%;
            text-align: center;
          }
        }
        .order_paid_main{
          margin-top: 5px;
          background-color: white;
          .order_paid_center {
            width: 100%;
            height: 100px;
            li {
              float: left;
              width: 25%;
              height: 100px;
              text-align: center;
              img {
                width: 90%;
                height: 92%;
                padding: 4% 5%;
              }
              p {
                margin-top: 25px;
                height: 50px;
                display: flex;
                align-items: center;
                span {
                  width: 100%;
                  text-align: center;
                }
              }
              label {
                margin: 0;
                display: inline-block;
                width: 100%;
              }
            }
          }
          .order_paid_Pcenter{
            height: 25px;
            width: 100%;
            line-height: 25px;
            display: flex;
            justify-content: flex-end;
            span{
              display: inline-block;
              margin: 0 15px;
              label{
                color: $navcolor;
                font-size: 16px;
              }
            }
          }
          .order_paid_footer {
            height: 40px;
            width: 100%;
            background-color: white;
            border-top: 1px solid #ddd;
            display: flex;
            justify-content: flex-end;
            span {
              display: inline-block;
              text-align: center;
              height: 20px;
              margin-top: 7px;
              line-height: 20px;
              margin-right: 20px;
              padding: 2px 10px;
              border-radius: 25px;
              font-size: 14px;
              letter-spacing: $letter;
              border: 1px solid $navcolor;
              color: $navcolor;
            }
          }
        }
      }
      .order_no {
      display: none;
      }
      .order_Pno {
        margin: 50px auto;
        width: 100%;
        line-height: 200px;
        display: flex;
        font-size: 14px;
        letter-spacing: 2px;
        justify-content: center;
        img {
          width: 100px;
          height: 200px;
        }
      }
    }
  }
  @media screen and(min-width: $P750screen){
    .order_paid {
      font-size: 14px;
      .order_have{
        .order_paid_top {
          margin-top: 2px;
          height: 40px;
          line-height: 40px;
          background-color: $bgcolor;
          li {
            float: left;
            width: 20%;
            text-align: center;
          }
        }
        .order_paid_main{
          background-color: white;
          margin-top: 1px;
          .order_paid_center {
            margin-top: 5px;
            background-color: white;
            height: 110px;
            li {
              height: 110px;
              float: left;
              width: 20%;
              display: flex;
              flex-direction: column;
              justify-content: center;
              text-align: center;
              img {
                margin-top: 10px;
              }
              p{
                width: 100%;
                height: 50px;
                margin: 25px 0;
                display: flex;
                align-items: center;
                span{
                  width: 100%;
                  text-align: center;
                }
              }
              button {
                border: none;
                background-color: white;
                outline: none;
              }
            }
          }
          .order_paid_footer {
            display: inline-block;
            padding: 10px 0;
            margin-top: 2px;
            width: 100%;
            height: 20px;
            line-height: 20px;
            background-color: $bgcolor;
            font-size: 14px;
            span {
              float: right;
              margin-right: 20px;
              label {
                color: $navcolor;
                font-size: 20px;
              }
            }
          }
        }
      }
      .order_Phave{
       display: none;
      }
      .order_no {
        margin: 0 auto;
        margin-top: 50px;
        height: 315px;
        width: 100%;
        line-height: 326px;
        display: flex;
        font-size: 18px;
        letter-spacing: 2px;
        justify-content: center;
        a{
          color:$navcolor;
        }
      }
      .order_Pno {
        display: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/personal/order_paid.vue